import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button, makeStyles, mergeClasses, tokens } from '@fluentui/react-components';

import { I18nContext } from '@bingads-webui-react/i18n-context';

const useStyles = makeStyles({
  buttonStyle: {
    marginRight: tokens.spacingHorizontalS,
    marginTop: tokens.spacingVerticalL,
  },
});

export const AdEditorFooter = ({
  cancel,
  save,
  saveAndCreateAnother,
}) => {
  const classes = useStyles();
  const i18n = useContext(I18nContext);

  return (
    <div className="footer-container">
      <Button appearance="primary" onClick={save} className={mergeClasses(classes.buttonStyle, 'save')}>
        {i18n.getString(_TL_('Save'))}
      </Button>
      <Button onClick={saveAndCreateAnother} className={mergeClasses(classes.buttonStyle, 'save-create-another')}>
        {i18n.getString(_TL_('Save and create another'))}
      </Button>
      <Button onClick={cancel} className={mergeClasses(classes.buttonStyle, 'cancel')}>
        {i18n.getString(_TL_('Cancel'))}
      </Button>
    </div>
  );
};

AdEditorFooter.propTypes = {
  cancel: PropTypes.func.isRequired,
  save: PropTypes.func.isRequired,
  saveAndCreateAnother: PropTypes.func.isRequired,
};
